<template>
  <section class="s-page-not-found">
    <div class="container">
      <img src="@/assets/img/icon-not-found.svg" alt="" />
      <h1>Desculpe, essa página não está disponível.</h1>
      <p>
        O link que você buscou pode estar quebrado ou a página pode ter sido removida
      </p>
      <router-link :to="{ name: 'app.home' }">
        <a href="" class="btn">Voltar para página inicial</a>
      </router-link>
    </div>
  </section>
</template>
<style lang="scss" scoped>
.s-page-not-found {
  margin-top: 8.8rem;
  padding-top: 6.6rem;
  background: url('../assets/img/bg-not-found.png') no-repeat top 6.6rem center;
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  h1 {
    max-width: 57.2rem;
    text-align: center;
    margin-bottom: 4.6rem;
  }
  p {
    text-align: center;
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 150%;
    color: #ffffff;
    opacity: 0.8;
    margin-bottom: 4rem;
  }
  .btn {
    width: 27rem;
    height: 4.8rem;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border: 1px solid #ffffff;
    font-weight: bold;
    font-size: 1.5rem;
    color: #191b21;
  }
}
</style>
